<template>
    <div>
        <Modal v-model="modalShow" :title="$t('Line_Manager')" width="70%"><!-- 直线上级 -->
            <Form inline label-position="left" :label-width="80"  >
                <Row :gutter="10">
                    <Col span="6">
                        <FormItem :label="$t('Name')" ><!-- 姓名 -->
                            <Input v-model="searchItem.userName" ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem :label="$t('English_Name')" ><!-- 英文名 -->
                            <Input v-model="searchItem.userEName" ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem :label="$t('Employee_Code')"><!-- 员工号 -->
                            <Input v-model="searchItem.empCode" ></Input>
                        </FormItem>
                    </Col>
                    <Col span="2">
                        <Button type="primary" @click="pageInfo.pageNo=1,search()"><!-- 检索 -->{{$t('Search')}}</Button>
                    </Col>
                </Row>
            </Form> 
            <Table border :loading="loading" :columns="columns" :data="data" style="margin:20px 0">
                <template slot-scope="{ row, index }" slot="action">
                    <Button type="primary" icon="md-reorder" size="small" @click="selectBtn(row, index)"></Button>
                </template>
            </Table>
            <div style="margin:20px 0;display:flex;justify-content: flex-end;">
                <Page :total="total" :current="pageInfo.pageNo" @on-change="pageChange"/>
            </div>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return{
            searchItem:{},
            modalShow:false,
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[]
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('PB_Select_Search'),/* 选择 */
                    slot: "action",
                    align: "center",
                    minWidth:80
                },
                {
                    title: this.$t('Employee_Code'),/* 员工号 */
                    key: "empCode",
                    align: "center",
                    minWidth:120
                },
                {
                    title: this.$t('Name'),/* 姓名 */
                    key: "userName",
                    align: "center",
                    minWidth:120
                },{
                    title: this.$t('English_Name'),/* 英文名 */
                    key: "userEName",
                    align: "center",
                    minWidth: 120
                },{
                    title: this.$t('BU'),/* 业务单元 */
                    key: this.lang=='zh'?"businessUnit":"enBusinessUnit",
                    align: "center",
                    minWidth: 200
                }, {
                    title: this.$t('Department'),/* 大区 */
                    key: this.lang=='zh'?"department":"enDepartment",
                    align: "center",
                    minWidth: 200
                }, {
                    title: this.$t('Funciton'),/* 职能 */
                    key: this.lang=='zh'?"postFun":"enPostFun",
                    align: "center",
                    minWidth: 200
                },
                
            ]
        },
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    created(){
        this.search()
    },
    methods:{
        search(){
            this.loading=true
            axios.post("/achReport/selectdirSupList", {...this.pageInfo,...this.searchItem}).then((res) => {
                if (res) {
                    this.data=res.data
                    this.total = parseInt(res.pageInfo.total)
                }
                this.loading=false
            })
        },
        selectBtn(row,index){
            this.$emit('selectRow',JSON.stringify(row))
            this.modalShow=false
        },
         pageChange(val){
            this.pageInfo.pageNo = val;
            this.search()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/modalComponents/DirModalComponent.vue